export default __webpack_public_path__ + "static/media/shutters-icon.02ac4e9d.svg";